<div class="one" fxLayout="column" [formGroup]="MatterConveyancingDetailsForm">
  <div fxLayout="row" fxLayoutAlign="start center" class="checkbox-row">
    <mat-checkbox class="checkbox-item" formControlName="INCLUSIONAIRCONDITIONING">
      Air Conditioning
    </mat-checkbox>
    <mat-checkbox class="checkbox-item" formControlName="INCLUSIONCEILINGFANS">
      Ceiling Fans
    </mat-checkbox>
    <mat-checkbox class="checkbox-item" formControlName="INCLUSIONBLINDS">Blinds</mat-checkbox>
    <mat-checkbox class="checkbox-item" formControlName="INCLUSIONCURTAINS">Curtains</mat-checkbox>
    <mat-checkbox class="checkbox-item" formControlName="INCLUSIONINSECTSCREENS">
      Insect Screens
    </mat-checkbox>
    <mat-checkbox class="checkbox-item" formControlName="INCLUSIONSTOVE">Stove</mat-checkbox>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" class="checkbox-row">
    <mat-checkbox class="checkbox-item" formControlName="INCLUSIONBUILTINWARDROBES">
      Built-in Wardrobes
    </mat-checkbox>
    <mat-checkbox class="checkbox-item" formControlName="INCLUSIONDISHWASHER">
      Dishwasher
    </mat-checkbox>
    <mat-checkbox class="checkbox-item" formControlName="INCLUSIONLIGHTFITTINGS">
      Light Fittings
    </mat-checkbox>
    <mat-checkbox class="checkbox-item" formControlName="INCLUSIONPOOLEQUIPMENT">
      Pool Equipment
    </mat-checkbox>
    <mat-checkbox class="checkbox-item" formControlName="INCLUSIONCLOTHESLINE">
      Clothes Line
    </mat-checkbox>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" class="checkbox-row">
    <mat-checkbox class="checkbox-item" formControlName="INCLUSIONFIXEDFLOORCOVERINGS">
      Fixed Floor Coverings
    </mat-checkbox>
    <mat-checkbox class="checkbox-item" formControlName="INCLUSIONRANGEHOOD">
      Rangehood
    </mat-checkbox>
    <mat-checkbox class="checkbox-item" formControlName="INCLUSIONTVANTENNA">
      TV Antenna
    </mat-checkbox>
    <mat-checkbox class="checkbox-item" formControlName="INCLUSIONSOLARPANELS">
      Solar Panels
    </mat-checkbox>
    <mat-checkbox class="checkbox-item" formControlName="INCLUSIONEVCHARGER">
      EV Charger
    </mat-checkbox>
  </div>
  <div class="other-details-row">
    <mat-checkbox formControlName="INCLUSIONOTHER" class="other-checkbox">Other</mat-checkbox>
    <mat-form-field appearance="outline" class="details-input">
      <mat-label>Details</mat-label>
      <input matInput formControlName="INCLUSIONOTHERDETAILS" type="text" />
    </mat-form-field>
  </div>

  <div class="exclusions-row">
    <mat-form-field appearance="outline" class="details-input">
      <mat-label>Exclusions</mat-label>
      <input matInput formControlName="EXCLUSIONS" type="text" />
    </mat-form-field>
  </div>
</div>
